import dayjs from 'dayjs'

const dateFormat = 'YYYY-MM-DD'

export enum KeywordReportPeriod {
    LastDay = 'LAST_DAY',
    Last7Days = 'LAST_7_DAYS',
    Last30Days = 'LAST_30_DAYS',
}

export const keywordReportPeriodLabels: Record<KeywordReportPeriod, string> = {
    [KeywordReportPeriod.LastDay]: '1 Day',
    [KeywordReportPeriod.Last7Days]: '7 Days',
    [KeywordReportPeriod.Last30Days]: '30 Days',
}

const periodDays: Record<KeywordReportPeriod, number> = {
    [KeywordReportPeriod.LastDay]: 1,
    [KeywordReportPeriod.Last7Days]: 7,
    [KeywordReportPeriod.Last30Days]: 30,
}

export const periodDates = (period: KeywordReportPeriod, now: dayjs.Dayjs = dayjs()): { start: string, end: string } => ({
    start: now.subtract(periodDays[period], 'day').format(dateFormat),
    end: now.subtract(1, 'day').format(dateFormat),
})



// WEBPACK FOOTER //
// ./src/component/app/keywordReport/keywordReportRequest.ts